
// // import React, { useEffect, useRef, useState } from "react";
// // import {
// //   FiLayers,
// //   FiDollarSign,
// //   FiArrowUpRight,
// //   FiBox,
// //   FiPieChart,
// //   FiHome,
// //   FiCheckCircle,
// //   FiFileText,
// //   FiSearch,
// //   FiClipboard,
// //   FiTool,
// // } from "react-icons/fi";

// // const Services = () => {
// //   const sectionRef = useRef(null);
// //   const [visible, setVisible] = useState(false);
// //   const [activeService, setActiveService] = useState(null);

// //   useEffect(() => {
// //     const observer = new IntersectionObserver(
// //       ([entry]) => {
// //         if (entry.isIntersecting) {
// //           setVisible(true);
// //         }
// //       },
// //       { threshold: 0.1 }
// //     );

// //     if (sectionRef.current) {
// //       observer.observe(sectionRef.current);
// //     }

// //     return () => observer.disconnect();
// //   }, []);

// //   const services = [
// //     {
// //       id: "01",
// //       title: "Quantity Takeoffs",
// //       short: "Precise quantities from your drawings.",
// //       description:
// //         "We extract, measure, organize, and quantify construction materials and components from architectural, structural, civil, and project drawings.",
// //       image:
// //         "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=90",
// //       icon: FiLayers,
// //       deliverables: [
// //         "Material quantities",
// //         "Trade-specific takeoffs",
// //         "Drawing-based measurements",
// //         "Quantity breakdowns",
// //       ],
// //     },

// //     {
// //       id: "02",
// //       title: "Construction Estimating",
// //       short: "Detailed project cost development.",
// //       description:
// //         "We develop structured estimates covering material, labor, equipment, subcontractor scope, and other applicable project costs.",
// //       image:
// //         "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=90",
// //       icon: FiDollarSign,
// //       deliverables: [
// //         "Material costs",
// //         "Labor costs",
// //         "Equipment costs",
// //         "Trade-level pricing",
// //       ],
// //     },

// //     {
// //       id: "03",
// //       title: "Bid Preparation",
// //       short: "Better numbers for competitive bids.",
// //       description:
// //         "We organize project scope and cost information to support contractors during bid preparation, review, and submission.",
// //       image:
// //         "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=90",
// //       icon: FiArrowUpRight,
// //       deliverables: [
// //         "Bid-ready estimates",
// //         "Scope breakdowns",
// //         "Cost summaries",
// //         "Bid review support",
// //       ],
// //     },

// //     {
// //       id: "04",
// //       title: "Material Takeoffs",
// //       short: "Know exactly what the project needs.",
// //       description:
// //         "We identify and quantify project materials to help contractors understand procurement requirements and project scope.",
// //       image:
// //         "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=90",
// //       icon: FiBox,
// //       deliverables: [
// //         "Material lists",
// //         "Quantity schedules",
// //         "Trade breakdowns",
// //         "Procurement support",
// //       ],
// //     },

// //     {
// //       id: "05",
// //       title: "Cost Analysis",
// //       short: "Clear visibility into project costs.",
// //       description:
// //         "We organize project costs into understandable categories so your team can evaluate scope, pricing, and potential cost impacts.",
// //       image:
// //         "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=90",
// //       icon: FiPieChart,
// //       deliverables: [
// //         "Cost summaries",
// //         "Trade-level analysis",
// //         "Scope comparisons",
// //         "Budget visibility",
// //       ],
// //     },

// //     {
// //       id: "06",
// //       title: "Preconstruction Support",
// //       short: "Estimating support before construction begins.",
// //       description:
// //         "We support early-stage project planning with quantity takeoffs, preliminary estimates, scope review, and cost information.",
// //       image:
// //         "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=90",
// //       icon: FiHome,
// //       deliverables: [
// //         "Preliminary estimates",
// //         "Scope review",
// //         "Concept-level quantities",
// //         "Budget support",
// //       ],
// //     },
// //   ];

// //   const divisions = [
// //     {
// //       number: "01",
// //       title: "General Requirements / GC",
// //       text: "Project administration, temporary facilities, general conditions, and related requirements.",
// //     },
// //     {
// //       number: "02",
// //       title: "Existing Conditions",
// //       text: "Existing construction, demolition, removals, and site condition scope.",
// //     },
// //     {
// //       number: "03",
// //       title: "Concrete",
// //       text: "Foundations, slabs, structural concrete, reinforcing, formwork, and related work.",
// //     },
// //     {
// //       number: "04",
// //       title: "Masonry",
// //       text: "Concrete masonry units, brick, stone, mortar, reinforcing, and masonry accessories.",
// //     },
// //     {
// //       number: "05",
// //       title: "Metals",
// //       text: "Structural steel, miscellaneous metals, metal fabrications, and related components.",
// //     },
// //     {
// //       number: "07",
// //       title: "Thermal & Moisture Protection",
// //       text: "Roofing, waterproofing, insulation, sealants, flashing, and moisture protection.",
// //     },
// //     {
// //       number: "08",
// //       title: "Openings",
// //       text: "Doors, frames, hardware, windows, glazing, and related opening systems.",
// //     },
// //     {
// //       number: "09",
// //       title: "Finishes",
// //       text: "Drywall, ceilings, flooring, painting, coatings, and interior finish systems.",
// //     },
// //     {
// //       number: "32",
// //       title: "Exterior Improvements",
// //       text: "Paving, landscaping, site furnishings, curbs, exterior structures, and improvements.",
// //     },
// //   ];

// //   const deliverables = [
// //     {
// //       icon: FiLayers,
// //       title: "Detailed Takeoff",
// //       text: "Organized quantities by trade and scope.",
// //     },
// //     {
// //       icon: FiDollarSign,
// //       title: "Cost Estimate",
// //       text: "Material and labor cost information.",
// //     },
// //     {
// //       icon: FiSearch,
// //       title: "Scope Review",
// //       text: "Drawing and document-based scope analysis.",
// //     },
// //     {
// //       icon: FiCheckCircle,
// //       title: "Quality Review",
// //       text: "Structured review before final delivery.",
// //     },
// //   ];

// //   return (
// //     <>
// //       <style>{`

// //         /* =====================================================
// //            SERVICES SECTION
// //         ===================================================== */

// //         .sg-services {
// //           position: relative;
// //           overflow: hidden;

// //           padding: 125px 0;

// //           background: #f7faff;
// //         }

// //         .sg-services-container {
// //           position: relative;
// //           z-index: 2;

// //           width: min(1380px, 92%);
// //           margin: auto;
// //         }

// //         /* =====================================================
// //            BLUEPRINT BACKGROUND
// //         ===================================================== */

// //         .sg-services-blueprint {
// //           position: absolute;

// //           top: 0;
// //           left: -180px;

// //           width: 650px;
// //           height: 650px;

// //           opacity: 0.42;

// //           background-image:
// //             linear-gradient(
// //               rgba(24, 87, 173, 0.055) 1px,
// //               transparent 1px
// //             ),
// //             linear-gradient(
// //               90deg,
// //               rgba(24, 87, 173, 0.055) 1px,
// //               transparent 1px
// //             );

// //           background-size: 35px 35px;

// //           transform: rotate(-5deg);

// //           pointer-events: none;
// //         }

// //         .sg-services-blueprint::after {
// //           content: "";

// //           position: absolute;

// //           width: 350px;
// //           height: 350px;

// //           left: 170px;
// //           top: 130px;

// //           border: 1px solid rgba(23, 88, 180, 0.08);

// //           transform: rotate(25deg);
// //         }

// //         /* =====================================================
// //            HEADER
// //         ===================================================== */

// //         .sg-services-heading {
// //           display: grid;

// //           grid-template-columns: 0.9fr 1.1fr;

// //           gap: 80px;

// //           align-items: end;

// //           margin-bottom: 65px;

// //           opacity: 0;

// //           transform: translateY(30px);

// //           transition:
// //             opacity 0.7s ease,
// //             transform 0.7s ease;
// //         }

// //         .sg-services-heading.visible {
// //           opacity: 1;
// //           transform: translateY(0);
// //         }

// //         .sg-services-label {
// //           display: inline-flex;

// //           align-items: center;

// //           gap: 9px;

// //           color: #175bc3;

// //           font-size: 12px;

// //           font-weight: 800;

// //           letter-spacing: 1.5px;

// //           text-transform: uppercase;
// //         }

// //         .sg-services-label-line {
// //           width: 30px;
// //           height: 2px;

// //           border-radius: 10px;

// //           background: #f39818;
// //         }

// //         .sg-services-title {
// //           margin: 16px 0 0;

// //           color: #10213f;

// //           font-size: clamp(40px, 4.2vw, 62px);

// //           line-height: 1.04;

// //           letter-spacing: -2.5px;

// //           font-weight: 800;
// //         }

// //         .sg-services-title span {
// //           color: #1b60c8;
// //         }

// //         .sg-services-intro {
// //           max-width: 650px;

// //           margin: 0;

// //           color: #68768a;

// //           font-size: 16px;

// //           line-height: 1.8;
// //         }

// //         /* =====================================================
// //            SERVICE CARDS
// //         ===================================================== */

// //         .sg-service-grid {
// //           display: grid;

// //           grid-template-columns:
// //             repeat(3, minmax(0, 1fr));

// //           gap: 20px;
// //         }

// //         .sg-service-card {
// //           position: relative;

// //           overflow: hidden;

// //           min-height: 440px;

// //           border: 1px solid #dfe8f2;

// //           border-radius: 18px;

// //           background: #ffffff;

// //           box-shadow:
// //             0 12px 35px rgba(25, 61, 103, 0.055);

// //           opacity: 0;

// //           transform: translateY(35px);

// //           transition:
// //             opacity 0.7s ease,
// //             transform 0.7s ease,
// //             box-shadow 0.3s ease,
// //             border-color 0.3s ease;
// //         }

// //         .sg-service-card.visible {
// //           opacity: 1;

// //           transform: translateY(0);
// //         }

// //         .sg-service-card:nth-child(2) {
// //           transition-delay: 0.08s;
// //         }

// //         .sg-service-card:nth-child(3) {
// //           transition-delay: 0.16s;
// //         }

// //         .sg-service-card:nth-child(4) {
// //           transition-delay: 0.24s;
// //         }

// //         .sg-service-card:nth-child(5) {
// //           transition-delay: 0.32s;
// //         }

// //         .sg-service-card:nth-child(6) {
// //           transition-delay: 0.40s;
// //         }

// //         .sg-service-card:hover {
// //           transform: translateY(-8px);

// //           border-color: #cadcf1;

// //           box-shadow:
// //             0 25px 60px rgba(25, 61, 103, 0.13);
// //         }

// //         /* =====================================================
// //            SERVICE IMAGE
// //         ===================================================== */

// //         .sg-service-image {
// //           position: relative;

// //           height: 190px;

// //           overflow: hidden;
// //         }

// //         .sg-service-image img {
// //           width: 100%;
// //           height: 100%;

// //           display: block;

// //           object-fit: cover;

// //           transition:
// //             transform 0.55s ease,
// //             filter 0.55s ease;
// //         }

// //         .sg-service-card:hover
// //         .sg-service-image img {
// //           transform: scale(1.07);

// //           filter: saturate(1.05);
// //         }

// //         .sg-service-image::after {
// //           content: "";

// //           position: absolute;

// //           inset: 0;

// //           background:
// //             linear-gradient(
// //               180deg,
// //               rgba(10, 39, 73, 0.03),
// //               rgba(10, 39, 73, 0.43)
// //             );
// //         }

// //         /* =====================================================
// //            NUMBER
// //         ===================================================== */

// //         .sg-service-number {
// //           position: absolute;

// //           z-index: 3;

// //           top: 14px;
// //           left: 14px;

// //           width: 40px;
// //           height: 40px;

// //           display: flex;

// //           align-items: center;
// //           justify-content: center;

// //           border-radius: 9px;

// //           color: #1558c0;

// //           background: rgba(255,255,255,0.94);

// //           font-size: 11px;

// //           font-weight: 900;

// //           box-shadow:
// //             0 8px 20px rgba(15, 45, 80, 0.12);
// //         }

// //         /* =====================================================
// //            ICON
// //         ===================================================== */

// //         .sg-service-icon {
// //           position: absolute;

// //           z-index: 3;

// //           right: 15px;
// //           top: 15px;

// //           width: 38px;
// //           height: 38px;

// //           display: flex;

// //           align-items: center;
// //           justify-content: center;

// //           border-radius: 50%;

// //           color: white;

// //           background: #1558c0;

// //           border: 3px solid rgba(255,255,255,0.8);

// //           font-size: 13px;
// //         }

// //         /* =====================================================
// //            CARD CONTENT
// //         ===================================================== */

// //         .sg-service-content {
// //           padding: 22px 22px 20px;
// //         }

// //         .sg-service-title {
// //           margin: 0;

// //           color: #132641;

// //           font-size: 19px;

// //           line-height: 1.2;

// //           font-weight: 800;
// //         }

// //         .sg-service-short {
// //           margin: 7px 0 0;

// //           color: #1558c0;

// //           font-size: 10px;

// //           font-weight: 800;

// //           letter-spacing: 0.2px;
// //         }

// //         .sg-service-description {
// //           margin: 13px 0 0;

// //           color: #798598;

// //           font-size: 11px;

// //           line-height: 1.7;
// //         }

// //         /* =====================================================
// //            DELIVERABLES
// //         ===================================================== */

// //         .sg-service-deliverables {
// //           display: grid;

// //           grid-template-columns: 1fr 1fr;

// //           gap: 7px;

// //           margin-top: 17px;

// //           padding-top: 15px;

// //           border-top: 1px solid #edf1f5;
// //         }

// //         .sg-service-deliverable {
// //           display: flex;

// //           align-items: center;

// //           gap: 6px;

// //           color: #617086;

// //           font-size: 9px;

// //           font-weight: 600;
// //         }

// //         .sg-service-deliverable svg {
// //   width: 14px;
// //   height: 14px;
// //   flex-shrink: 0;
// //   color: #168258;
// //   stroke-width: 2.2;
// // }

// // //        .sg-service-deliverable::before {
// // //   content: "";
// // //   width: 16px;
// // //   height: 16px;
// // //   flex-shrink: 0;
// // //   border-radius: 50%;
// // //   color: #168258;
// // //   background: #eaf8f1;

// // //   display: flex;
// // //   align-items: center;
// // //   justify-content: center;
// // // }

// //         /* =====================================================
// //            CSI DIVISIONS
// //         ===================================================== */

// //         .sg-csi {
// //           margin-top: 105px;

// //           padding: 55px;

// //           border-radius: 24px;

// //           background:
// //             linear-gradient(
// //               135deg,
// //               #102b4d 0%,
// //               #174f8d 100%
// //             );

// //           box-shadow:
// //             0 25px 65px rgba(17, 51, 88, 0.18);

// //           position: relative;

// //           overflow: hidden;
// //         }

// //         .sg-csi::before {
// //           content: "";

// //           position: absolute;

// //           width: 480px;
// //           height: 480px;

// //           right: -200px;
// //           top: -250px;

// //           border: 1px solid rgba(255,255,255,0.09);

// //           border-radius: 50%;
// //         }

// //         .sg-csi::after {
// //           content: "";

// //           position: absolute;

// //           width: 300px;
// //           height: 300px;

// //           right: -110px;
// //           top: -160px;

// //           border: 1px dashed rgba(255,255,255,0.08);

// //           border-radius: 50%;
// //         }

// //         .sg-csi-heading {
// //           position: relative;

// //           z-index: 2;

// //           display: grid;

// //           grid-template-columns: 1fr 0.7fr;

// //           gap: 70px;

// //           align-items: end;

// //           margin-bottom: 38px;
// //         }

// //         .sg-csi-label {
// //           color: #f7a62c;

// //           font-size: 10px;

// //           font-weight: 800;

// //           letter-spacing: 1.5px;

// //           text-transform: uppercase;
// //         }

// //         .sg-csi-title {
// //           margin: 10px 0 0;

// //           color: white;

// //           font-size: clamp(30px, 3.1vw, 44px);

// //           line-height: 1.1;

// //           letter-spacing: -1.4px;

// //           font-weight: 800;
// //         }

// //         .sg-csi-text {
// //           margin: 0;

// //           color: rgba(255,255,255,0.65);

// //           font-size: 12px;

// //           line-height: 1.75;
// //         }

// //         .sg-csi-grid {
// //           position: relative;

// //           z-index: 2;

// //           display: grid;

// //           grid-template-columns:
// //             repeat(3, 1fr);

// //           gap: 10px;
// //         }

// //         .sg-csi-card {
// //           display: flex;

// //           align-items: center;

// //           gap: 13px;

// //           min-height: 72px;

// //           padding: 11px 14px;

// //           border: 1px solid rgba(255,255,255,0.10);

// //           border-radius: 11px;

// //           background: rgba(255,255,255,0.065);

// //           transition:
// //             background 0.25s ease,
// //             transform 0.25s ease,
// //             border-color 0.25s ease;
// //         }

// //         .sg-csi-card:hover {
// //           transform: translateY(-3px);

// //           background: rgba(255,255,255,0.12);

// //           border-color: rgba(255,255,255,0.20);
// //         }

// //         .sg-csi-number {
// //           width: 40px;
// //           height: 40px;

// //           flex-shrink: 0;

// //           display: flex;

// //           align-items: center;
// //           justify-content: center;

// //           border-radius: 8px;

// //           color: #16529d;

// //           background: #ffffff;

// //           font-size: 11px;

// //           font-weight: 900;
// //         }

// //         .sg-csi-card strong {
// //           display: block;

// //           color: white;

// //           font-size: 11px;

// //           line-height: 1.35;
// //         }

// //         .sg-csi-card span {
// //           display: block;

// //           margin-top: 3px;

// //           color: rgba(255,255,255,0.43);

// //           font-size: 8px;

// //           letter-spacing: 0.6px;

// //           text-transform: uppercase;
// //         }

// //         /* =====================================================
// //            DELIVERABLES
// //         ===================================================== */

// //         .sg-deliverables {
// //           margin-top: 105px;
// //         }

// //         .sg-deliverables-header {
// //           text-align: center;

// //           max-width: 720px;

// //           margin: 0 auto 45px;
// //         }

// //         .sg-deliverables-label {
// //           color: #f39818;

// //           font-size: 10px;

// //           font-weight: 800;

// //           letter-spacing: 1.4px;

// //           text-transform: uppercase;
// //         }

// //         .sg-deliverables-title {
// //           margin: 10px 0 13px;

// //           color: #10213f;

// //           font-size: clamp(30px, 3vw, 43px);

// //           line-height: 1.1;

// //           letter-spacing: -1.4px;

// //           font-weight: 800;
// //         }

// //         .sg-deliverables-text {
// //           margin: 0;

// //           color: #7a8799;

// //           font-size: 13px;

// //           line-height: 1.7;
// //         }

// //         .sg-deliverables-grid {
// //           display: grid;

// //           grid-template-columns:
// //             repeat(4, 1fr);

// //           gap: 15px;
// //         }

// //         .sg-deliverable-card {
// //           padding: 28px 23px;

// //           text-align: center;

// //           border: 1px solid #e0e8f2;

// //           border-radius: 15px;

// //           background: #ffffff;

// //           transition:
// //             transform 0.25s ease,
// //             box-shadow 0.25s ease,
// //             border-color 0.25s ease;
// //         }

// //         .sg-deliverable-card:hover {
// //           transform: translateY(-6px);

// //           border-color: #cbdcf0;

// //           box-shadow:
// //             0 18px 40px rgba(25, 61, 103, 0.09);
// //         }

// //         .sg-deliverable-icon {
// //           width: 51px;
// //           height: 51px;

// //           display: flex;

// //           align-items: center;
// //           justify-content: center;

// //           margin: auto;

// //           border-radius: 13px;

// //           color: #1558c0;

// //           background: #edf4ff;

// //           font-size: 20px;

// //           font-weight: 700;
// //         }

// //         .sg-service-icon svg {
// //   width: 17px;
// //   height: 17px;
// //   stroke-width: 2.2;
// // }

// //         .sg-deliverable-card h4 {
// //           margin: 16px 0 7px;

// //           color: #172945;

// //           font-size: 14px;

// //           font-weight: 800;
// //         }

// //         .sg-deliverable-card p {
// //           margin: 0;

// //           color: #8490a0;

// //           font-size: 10px;

// //           line-height: 1.6;
// //         }

// //         /* =====================================================
// //            CTA
// //         ===================================================== */

// //         .sg-services-cta {
// //           position: relative;

// //           display: flex;

// //           align-items: center;
// //           justify-content: space-between;

// //           gap: 30px;

// //           margin-top: 80px;

// //           padding: 36px 40px;

// //           overflow: hidden;

// //           border-radius: 18px;

// //           background:
// //             linear-gradient(
// //               110deg,
// //               #edf5ff,
// //               #f8fbff
// //             );

// //           border: 1px solid #dbe6f2;
// //         }

// //         .sg-services-cta::after {
// //           content: "";

// //           position: absolute;

// //           width: 180px;
// //           height: 180px;

// //           right: -50px;
// //           top: -90px;

// //           border: 1px solid rgba(21,88,192,0.10);

// //           border-radius: 50%;
// //         }

// //         .sg-services-cta h3 {
// //           position: relative;

// //           z-index: 2;

// //           margin: 0;

// //           color: #10213f;

// //           font-size: 22px;

// //           font-weight: 800;
// //         }

// //         .sg-services-cta p {
// //           position: relative;

// //           z-index: 2;

// //           margin: 7px 0 0;

// //           color: #788598;

// //           font-size: 11px;
// //         }

// //         .sg-services-cta-button {
// //           position: relative;

// //           z-index: 2;

// //           display: inline-flex;

// //           align-items: center;
// //           justify-content: center;

// //           gap: 9px;

// //           min-height: 50px;

// //           padding: 0 23px;

// //           flex-shrink: 0;

// //           border-radius: 8px;

// //           color: #ffffff;

// //           background:
// //             linear-gradient(
// //               135deg,
// //               #1558c0,
// //               #2874dd
// //             );

// //           box-shadow:
// //             0 12px 25px rgba(21,88,192,0.20);

// //           text-decoration: none;

// //           font-size: 11px;

// //           font-weight: 800;

// //           transition:
// //             transform 0.25s ease,
// //             box-shadow 0.25s ease;
// //         }

// //         .sg-services-cta-button:hover {
// //           transform: translateY(-3px);

// //           box-shadow:
// //             0 16px 32px rgba(21,88,192,0.28);
// //         }

// //         /* =====================================================
// //            ANIMATION
// //         ===================================================== */

// //         @keyframes sgServicesFloat {
// //           0%,
// //           100% {
// //             transform: translateY(0);
// //           }

// //           50% {
// //             transform: translateY(-8px);
// //           }
// //         }

// //         /* =====================================================
// //            TABLET
// //         ===================================================== */

// //         @media (max-width: 1050px) {

// //           .sg-services {
// //             padding: 95px 0;
// //           }

// //           .sg-services-heading {
// //             gap: 40px;
// //           }

// //           .sg-service-grid {
// //             grid-template-columns:
// //               repeat(2, 1fr);
// //           }

// //           .sg-csi {
// //             padding: 40px 30px;
// //           }

// //           .sg-csi-heading {
// //             gap: 40px;
// //           }

// //           .sg-deliverables-grid {
// //             grid-template-columns:
// //               repeat(2, 1fr);
// //           }
// //         }

// //         /* =====================================================
// //            MOBILE
// //         ===================================================== */

// //         @media (max-width: 760px) {

// //           .sg-services {
// //             padding: 80px 0;
// //           }

// //           .sg-services-heading {
// //             grid-template-columns: 1fr;

// //             gap: 18px;

// //             text-align: center;

// //             margin-bottom: 45px;
// //           }

// //           .sg-services-label {
// //             justify-content: center;
// //           }

// //           .sg-services-title {
// //             font-size: 39px;

// //             letter-spacing: -1.7px;
// //           }

// //           .sg-services-intro {
// //             margin: auto;

// //             font-size: 15px;
// //           }

// //           .sg-service-grid {
// //             grid-template-columns: 1fr;

// //             max-width: 550px;

// //             margin: auto;
// //           }

// //           .sg-service-card {
// //             min-height: auto;
// //           }

// //           .sg-service-image {
// //             height: 215px;
// //           }

// //           .sg-csi {
// //             margin-top: 75px;

// //             padding: 35px 20px;
// //           }

// //           .sg-csi-heading {
// //             grid-template-columns: 1fr;

// //             gap: 15px;

// //             text-align: center;
// //           }

// //           .sg-csi-text {
// //             max-width: 500px;

// //             margin: auto;
// //           }

// //           .sg-csi-grid {
// //             grid-template-columns: 1fr;
// //           }

// //           .sg-deliverables {
// //             margin-top: 75px;
// //           }

// //           .sg-deliverables-title {
// //             font-size: 31px;
// //           }

// //           .sg-deliverables-grid {
// //             grid-template-columns: 1fr 1fr;
// //           }

// //           .sg-services-cta {
// //             display: block;

// //             text-align: center;

// //             padding: 30px 20px;
// //           }

// //           .sg-services-cta-button {
// //             width: 100%;

// //             margin-top: 22px;
// //           }
// //         }

// //         /* =====================================================
// //            SMALL MOBILE
// //         ===================================================== */

// //         @media (max-width: 480px) {

// //           .sg-services {
// //             padding: 65px 0;
// //           }

// //           .sg-services-title {
// //             font-size: 35px;
// //           }

// //           .sg-service-image {
// //             height: 195px;
// //           }

// //           .sg-service-content {
// //             padding: 20px;
// //           }

// //           .sg-csi-title {
// //             font-size: 28px;
// //           }

// //           .sg-deliverables-grid {
// //             grid-template-columns: 1fr;
// //           }

// //           .sg-services-cta h3 {
// //             font-size: 20px;
// //           }
// //         }

// //         .sg-deliverable-icon svg {
// //   width: 22px;
// //   height: 22px;
// //   stroke-width: 2;
// // }
// //   .sg-cta-icon {
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// // }

// // .sg-cta-icon svg {
// //   width: 16px;
// //   height: 16px;
// //   stroke-width: 2.5;
// // }

// //       `}</style>


// //       <section
// //         className="sg-services"
// //         id="services"
// //         ref={sectionRef}
// //       >

// //         <div className="sg-services-blueprint"></div>


// //         <div className="sg-services-container">

// //           {/* =================================================
// //               HEADER
// //           ================================================= */}

// //           <div
// //             className={`sg-services-heading ${visible ? "visible" : ""
// //               }`}
// //           >

// //             <div>

// //               <div className="sg-services-label">

// //                 <span className="sg-services-label-line"></span>

// //                 Our Services

// //               </div>

// //               <h2 className="sg-services-title">
// //                 Estimating Built
// //                 <br />
// //                 Around <span>Your Bid.</span>
// //               </h2>

// //             </div>


// //             <p className="sg-services-intro">
// //               From detailed quantity takeoffs to complete
// //               construction cost estimates, StructGuard provides
// //               the estimating support contractors need to
// //               understand project scope, evaluate costs, and
// //               prepare competitive bids.
// //             </p>

// //           </div>


// //           {/* =================================================
// //               SERVICES GRID
// //           ================================================= */}

// //           <div className="sg-service-grid">

// //             {services.map((service) => (

// //               <article
// //                 className={`sg-service-card ${visible ? "visible" : ""
// //                   }`}
// //                 key={service.id}
// //                 onMouseEnter={() =>
// //                   setActiveService(service.id)
// //                 }
// //                 onMouseLeave={() =>
// //                   setActiveService(null)
// //                 }
// //               >

// //                 {/* IMAGE */}

// //                 <div className="sg-service-image">

// //                   <img
// //                     src={service.image}
// //                     alt={service.title}
// //                   />

// //                   <div className="sg-service-number">
// //                     {service.id}
// //                   </div>

// //                   <div className="sg-service-icon">
// //                     <service.icon />
// //                   </div>

// //                 </div>


// //                 {/* CONTENT */}

// //                 <div className="sg-service-content">

// //                   <h3 className="sg-service-title">
// //                     {service.title}
// //                   </h3>

// //                   <div className="sg-service-short">
// //                     {service.short}
// //                   </div>

// //                   <p className="sg-service-description">
// //                     {service.description}
// //                   </p>


// //                   <div className="sg-service-deliverables">

// //                     {service.deliverables.map((item) => (
// //                       <div
// //                         className="sg-service-deliverable"
// //                         key={item}
// //                       >
// //                         <FiCheckCircle />
// //                         {item}
// //                       </div>
// //                     ))}

// //                   </div>

// //                 </div>

// //               </article>

// //             ))}

// //           </div>


// //           {/* =================================================
// //               CSI DIVISIONS
// //           ================================================= */}

// //           {/* <div className="sg-csi">

// //             <div className="sg-csi-heading">

// //               <div>

// //                 <div className="sg-csi-label">
// //                   CSI DIVISION COVERAGE
// //                 </div>

// //                 <h3 className="sg-csi-title">
// //                   One estimating partner.
// //                   <br />
// //                   Multiple construction trades.
// //                 </h3>

// //               </div>


// //               <p className="sg-csi-text">
// //                 Our estimating capabilities span multiple
// //                 construction divisions, giving contractors
// //                 access to organized cost information across
// //                 diverse project scopes.
// //               </p>

// //             </div>


// //             <div className="sg-csi-grid">

// //               {divisions.map((division) => (

// //                 <div
// //                   className="sg-csi-card"
// //                   key={division.number}
// //                 >

// //                   <div className="sg-csi-number">
// //                     {division.number}
// //                   </div>

// //                   <div>

// //                     <strong>
// //                       {division.title}
// //                     </strong>

// //                     <span>
// //                       CSI Division
// //                     </span>

// //                   </div>

// //                 </div>

// //               ))}

// //             </div>

// //           </div> */}


// //           {/* =================================================
// //               DELIVERABLES
// //           ================================================= */}

// //           <div className="sg-deliverables">

// //             <div className="sg-deliverables-header">

// //               <div className="sg-deliverables-label">
// //                 WHAT YOU RECEIVE
// //               </div>

// //               <h3 className="sg-deliverables-title">
// //                 Clear. Organized. Ready to Use.
// //               </h3>

// //               <p className="sg-deliverables-text">
// //                 Every project is structured around delivering
// //                 practical estimating information your team can
// //                 review and use for bidding and project planning.
// //               </p>

// //             </div>


// //             <div className="sg-deliverables-grid">

// //               {deliverables.map((item) => (

// //                 <div
// //                   className="sg-deliverable-card"
// //                   key={item.title}
// //                 >

// //                   <div className="sg-deliverable-icon">
// //                     <item.icon />
// //                   </div>

// //                   <h4>
// //                     {item.title}
// //                   </h4>

// //                   <p>
// //                     {item.text}
// //                   </p>

// //                 </div>

// //               ))}

// //             </div>

// //           </div>


// //           {/* =================================================
// //               CTA
// //           ================================================= */}

// //           <div className="sg-services-cta">

// //             <div>

// //               <h3>
// //                 Have a project ready for estimating?
// //               </h3>

// //               <p>
// //                 Share your drawings and project details with
// //                 StructGuard and let us prepare the numbers.
// //               </p>

// //             </div>


// //             <a
// //               href="#contact"
// //               className="sg-services-cta-button"
// //             >
// //               REQUEST AN ESTIMATE

// //               <span>
// //                 <FiArrowUpRight />
// //               </span>

// //             </a>

// //           </div>

// //         </div>

// //       </section>
// //     </>
// //   );
// // };

// // export default Services;



// import React, { useEffect, useRef, useState } from "react";
// import {
//   FiLayers,
//   FiDollarSign,
//   FiArrowUpRight,
//   FiBox,
//   FiPieChart,
//   FiHome,
//   FiCheckCircle,
//   FiFileText,
//   FiSearch,
//   FiClipboard,
//   FiTool,
// } from "react-icons/fi";

// const Services = () => {
//   const sectionRef = useRef(null);
//   const [visible, setVisible] = useState(false);
//   const [activeService, setActiveService] = useState(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setVisible(true);
//         }
//       },
//       { threshold: 0.1 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   const services = [
//     {
//       id: "01",
//       title: "Quantity Takeoffs",
//       short: "Precise quantities from your drawings.",
//       description:
//         "We extract, measure, organize, and quantify construction materials and components from architectural, structural, civil, and project drawings.",
//       image:
//         "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=90",
//       icon: FiLayers,
//       deliverables: [
//         "Material quantities",
//         "Trade-specific takeoffs",
//         "Drawing-based measurements",
//         "Quantity breakdowns",
//       ],
//     },

//     {
//       id: "02",
//       title: "Construction Estimating",
//       short: "Detailed project cost development.",
//       description:
//         "We develop structured estimates covering material, labor, equipment, subcontractor scope, and other applicable project costs.",
//       image:
//         "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=90",
//       icon: FiDollarSign,
//       deliverables: [
//         "Material costs",
//         "Labor costs",
//         "Equipment costs",
//         "Trade-level pricing",
//       ],
//     },

//     {
//       id: "03",
//       title: "Bid Preparation",
//       short: "Better numbers for competitive bids.",
//       description:
//         "We organize project scope and cost information to support contractors during bid preparation, review, and submission.",
//       image:
//         "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=90",
//       icon: FiArrowUpRight,
//       deliverables: [
//         "Bid-ready estimates",
//         "Scope breakdowns",
//         "Cost summaries",
//         "Bid review support",
//       ],
//     },

//     {
//       id: "04",
//       title: "Material Takeoffs",
//       short: "Know exactly what the project needs.",
//       description:
//         "We identify and quantify project materials to help contractors understand procurement requirements and project scope.",
//       image:
//         "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=90",
//       icon: FiBox,
//       deliverables: [
//         "Material lists",
//         "Quantity schedules",
//         "Trade breakdowns",
//         "Procurement support",
//       ],
//     },

//     {
//       id: "05",
//       title: "Cost Analysis",
//       short: "Clear visibility into project costs.",
//       description:
//         "We organize project costs into understandable categories so your team can evaluate scope, pricing, and potential cost impacts.",
//       image:
//         "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=90",
//       icon: FiPieChart,
//       deliverables: [
//         "Cost summaries",
//         "Trade-level analysis",
//         "Scope comparisons",
//         "Budget visibility",
//       ],
//     },

//     {
//       id: "06",
//       title: "Preconstruction Support",
//       short: "Estimating support before construction begins.",
//       description:
//         "We support early-stage project planning with quantity takeoffs, preliminary estimates, scope review, and cost information.",
//       image:
//         "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=90",
//       icon: FiHome,
//       deliverables: [
//         "Preliminary estimates",
//         "Scope review",
//         "Concept-level quantities",
//         "Budget support",
//       ],
//     },
//   ];

//   const divisions = [
//     {
//       number: "01",
//       title: "General Requirements / GC",
//       text: "Project administration, temporary facilities, general conditions, and related requirements.",
//     },
//     {
//       number: "02",
//       title: "Existing Conditions",
//       text: "Existing construction, demolition, removals, and site condition scope.",
//     },
//     {
//       number: "03",
//       title: "Concrete",
//       text: "Foundations, slabs, structural concrete, reinforcing, formwork, and related work.",
//     },
//     {
//       number: "04",
//       title: "Masonry",
//       text: "Concrete masonry units, brick, stone, mortar, reinforcing, and masonry accessories.",
//     },
//     {
//       number: "05",
//       title: "Metals",
//       text: "Structural steel, miscellaneous metals, metal fabrications, and related components.",
//     },
//     {
//       number: "07",
//       title: "Thermal & Moisture Protection",
//       text: "Roofing, waterproofing, insulation, sealants, flashing, and moisture protection.",
//     },
//     {
//       number: "08",
//       title: "Openings",
//       text: "Doors, frames, hardware, windows, glazing, and related opening systems.",
//     },
//     {
//       number: "09",
//       title: "Finishes",
//       text: "Drywall, ceilings, flooring, painting, coatings, and interior finish systems.",
//     },
//     {
//       number: "32",
//       title: "Exterior Improvements",
//       text: "Paving, landscaping, site furnishings, curbs, exterior structures, and improvements.",
//     },
//   ];

//   const deliverables = [
//     {
//       icon: FiLayers,
//       title: "Detailed Takeoff",
//       text: "Organized quantities by trade and scope.",
//     },
//     {
//       icon: FiDollarSign,
//       title: "Cost Estimate",
//       text: "Material and labor cost information.",
//     },
//     {
//       icon: FiSearch,
//       title: "Scope Review",
//       text: "Drawing and document-based scope analysis.",
//     },
//     {
//       icon: FiCheckCircle,
//       title: "Quality Review",
//       text: "Structured review before final delivery.",
//     },
//   ];

//   return (
//     <>
//       <style>{`

//         /* =====================================================
//            SERVICES SECTION
//         ===================================================== */

//         .sg-services {
//           position: relative;
//           overflow: hidden;

//           padding: 125px 0;

//           background: #f7faff;
//         }

//         .sg-services-container {
//           position: relative;
//           z-index: 2;

//           width: min(1380px, 92%);
//           margin: auto;
//         }

//         /* =====================================================
//            BLUEPRINT BACKGROUND
//         ===================================================== */

//         .sg-services-blueprint {
//           position: absolute;

//           top: 0;
//           left: -180px;

//           width: 650px;
//           height: 650px;

//           opacity: 0.42;

//           background-image:
//             linear-gradient(
//               rgba(24, 87, 173, 0.055) 1px,
//               transparent 1px
//             ),
//             linear-gradient(
//               90deg,
//               rgba(24, 87, 173, 0.055) 1px,
//               transparent 1px
//             );

//           background-size: 35px 35px;

//           transform: rotate(-5deg);

//           pointer-events: none;
//         }

//         .sg-services-blueprint::after {
//           content: "";

//           position: absolute;

//           width: 350px;
//           height: 350px;

//           left: 170px;
//           top: 130px;

//           border: 1px solid rgba(23, 88, 180, 0.08);

//           transform: rotate(25deg);
//         }

//         /* =====================================================
//            HEADER
//         ===================================================== */

//         .sg-services-heading {
//           display: grid;

//           grid-template-columns: 0.9fr 1.1fr;

//           gap: 80px;

//           align-items: end;

//           margin-bottom: 65px;

//           opacity: 0;

//           transform: translateY(30px);

//           transition:
//             opacity 0.7s ease,
//             transform 0.7s ease;
//         }

//         .sg-services-heading.visible {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         .sg-services-label {
//           display: inline-flex;

//           align-items: center;

//           gap: 9px;

//           color: #175bc3;

//           font-size: 12px;

//           font-weight: 800;

//           letter-spacing: 1.5px;

//           text-transform: uppercase;
//         }

//         .sg-services-label-line {
//           width: 30px;
//           height: 2px;

//           border-radius: 10px;

//           background: #f39818;
//         }

//         .sg-services-title {
//           margin: 16px 0 0;

//           color: #10213f;

//           font-size: clamp(40px, 4.2vw, 62px);

//           line-height: 1.04;

//           letter-spacing: -2.5px;

//           font-weight: 800;
//         }

//         .sg-services-title span {
//           color: #1b60c8;
//         }

//         .sg-services-intro {
//           max-width: 650px;

//           margin: 0;

//           color: #68768a;

//           font-size: 16px;

//           line-height: 1.8;
//         }

//         /* =====================================================
//            SERVICE CARDS
//         ===================================================== */

//         .sg-service-grid {
//           display: grid;

//           grid-template-columns:
//             repeat(3, minmax(0, 1fr));

//           gap: 20px;
//         }

//         .sg-service-card {
//           position: relative;

//           overflow: hidden;

//           min-height: 440px;

//           border: 1px solid #dfe8f2;

//           border-radius: 18px;

//           background: #ffffff;

//           box-shadow:
//             0 12px 35px rgba(25, 61, 103, 0.055);

//           opacity: 0;

//           transform: translateY(35px);

//           transition:
//             opacity 0.7s ease,
//             transform 0.7s ease,
//             box-shadow 0.3s ease,
//             border-color 0.3s ease;
//         }

//         .sg-service-card.visible {
//           opacity: 1;

//           transform: translateY(0);
//         }

//         .sg-service-card:nth-child(2) {
//           transition-delay: 0.08s;
//         }

//         .sg-service-card:nth-child(3) {
//           transition-delay: 0.16s;
//         }

//         .sg-service-card:nth-child(4) {
//           transition-delay: 0.24s;
//         }

//         .sg-service-card:nth-child(5) {
//           transition-delay: 0.32s;
//         }

//         .sg-service-card:nth-child(6) {
//           transition-delay: 0.40s;
//         }

//         .sg-service-card:hover {
//           transform: translateY(-8px);

//           border-color: #cadcf1;

//           box-shadow:
//             0 25px 60px rgba(25, 61, 103, 0.13);
//         }

//         /* =====================================================
//            SERVICE IMAGE
//         ===================================================== */

//         .sg-service-image {
//           position: relative;

//           height: 190px;

//           overflow: hidden;
//         }

//         .sg-service-image img {
//           width: 100%;
//           height: 100%;

//           display: block;

//           object-fit: cover;

//           transition:
//             transform 0.55s ease,
//             filter 0.55s ease;
//         }

//         .sg-service-card:hover
//         .sg-service-image img {
//           transform: scale(1.07);

//           filter: saturate(1.05);
//         }

//         .sg-service-image::after {
//           content: "";

//           position: absolute;

//           inset: 0;

//           background:
//             linear-gradient(
//               180deg,
//               rgba(10, 39, 73, 0.03),
//               rgba(10, 39, 73, 0.43)
//             );
//         }

//         /* =====================================================
//            NUMBER
//         ===================================================== */

//         .sg-service-number {
//           position: absolute;

//           z-index: 3;

//           top: 14px;
//           left: 14px;

//           width: 40px;
//           height: 40px;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 9px;

//           color: #1558c0;

//           background: rgba(255,255,255,0.94);

//           font-size: 11px;

//           font-weight: 900;

//           box-shadow:
//             0 8px 20px rgba(15, 45, 80, 0.12);
//         }

//         /* =====================================================
//            ICON
//         ===================================================== */

//         .sg-service-icon {
//           position: absolute;

//           z-index: 3;

//           right: 15px;
//           top: 15px;

//           width: 38px;
//           height: 38px;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 50%;

//           color: white;

//           background: #1558c0;

//           border: 3px solid rgba(255,255,255,0.8);

//           font-size: 13px;
//         }

//         /* =====================================================
//            CARD CONTENT
//         ===================================================== */

//         .sg-service-content {
//           padding: 22px 22px 20px;
//         }

//         .sg-service-title {
//           margin: 0;

//           color: #132641;

//           font-size: 19px;

//           line-height: 1.2;

//           font-weight: 800;
//         }

//         .sg-service-short {
//           margin: 7px 0 0;

//           color: #1558c0;

//           font-size: 10px;

//           font-weight: 800;

//           letter-spacing: 0.2px;
//         }

//         .sg-service-description {
//           margin: 13px 0 0;

//           color: #798598;

//           font-size: 11px;

//           line-height: 1.7;
//         }

//         /* =====================================================
//            DELIVERABLES
//         ===================================================== */

//         .sg-service-deliverables {
//           display: grid;

//           grid-template-columns: 1fr 1fr;

//           gap: 7px;

//           margin-top: 17px;

//           padding-top: 15px;

//           border-top: 1px solid #edf1f5;
//         }

//         .sg-service-deliverable {
//           display: flex;

//           align-items: center;

//           gap: 6px;

//           color: #617086;

//           font-size: 9px;

//           font-weight: 600;
//         }

//         .sg-service-deliverable svg {
//           width: 14px;
//           height: 14px;
//           flex-shrink: 0;
//           color: #168258;
//           stroke-width: 2.2;
//         }

//         /* =====================================================
//            CSI DIVISIONS (ACTIVATED)
//         ===================================================== */

//         .sg-csi {
//           margin-top: 105px;

//           padding: 55px;

//           border-radius: 24px;

//           background:
//             linear-gradient(
//               135deg,
//               #102b4d 0%,
//               #174f8d 100%
//             );

//           box-shadow:
//             0 25px 65px rgba(17, 51, 88, 0.18);

//           position: relative;

//           overflow: hidden;
//         }

//         .sg-csi::before {
//           content: "";

//           position: absolute;

//           width: 480px;
//           height: 480px;

//           right: -200px;
//           top: -250px;

//           border: 1px solid rgba(255,255,255,0.09);

//           border-radius: 50%;
//         }

//         .sg-csi::after {
//           content: "";

//           position: absolute;

//           width: 300px;
//           height: 300px;

//           right: -110px;
//           top: -160px;

//           border: 1px dashed rgba(255,255,255,0.08);

//           border-radius: 50%;
//         }

//         .sg-csi-heading {
//           position: relative;

//           z-index: 2;

//           display: grid;

//           grid-template-columns: 1fr 0.7fr;

//           gap: 70px;

//           align-items: end;

//           margin-bottom: 38px;
//         }

//         .sg-csi-label {
//           color: #f7a62c;

//           font-size: 10px;

//           font-weight: 800;

//           letter-spacing: 1.5px;

//           text-transform: uppercase;
//         }

//         .sg-csi-title {
//           margin: 10px 0 0;

//           color: white;

//           font-size: clamp(30px, 3.1vw, 44px);

//           line-height: 1.1;

//           letter-spacing: -1.4px;

//           font-weight: 800;
//         }

//         .sg-csi-text {
//           margin: 0;

//           color: rgba(255,255,255,0.65);

//           font-size: 12px;

//           line-height: 1.75;
//         }

//         .sg-csi-grid {
//           position: relative;

//           z-index: 2;

//           display: grid;

//           grid-template-columns:
//             repeat(3, 1fr);

//           gap: 10px;
//         }

//         .sg-csi-card {
//           display: flex;

//           align-items: center;

//           gap: 13px;

//           min-height: 72px;

//           padding: 11px 14px;

//           border: 1px solid rgba(255,255,255,0.10);

//           border-radius: 11px;

//           background: rgba(255,255,255,0.065);

//           transition:
//             background 0.25s ease,
//             transform 0.25s ease,
//             border-color 0.25s ease;
//         }

//         .sg-csi-card:hover {
//           transform: translateY(-3px);

//           background: rgba(255,255,255,0.12);

//           border-color: rgba(255,255,255,0.20);
//         }

//         .sg-csi-number {
//           width: 40px;
//           height: 40px;

//           flex-shrink: 0;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 8px;

//           color: #16529d;

//           background: #ffffff;

//           font-size: 11px;

//           font-weight: 900;
//         }

//         .sg-csi-card strong {
//           display: block;

//           color: white;

//           font-size: 11px;

//           line-height: 1.35;
//         }

//         .sg-csi-card span {
//           display: block;

//           margin-top: 3px;

//           color: rgba(255,255,255,0.43);

//           font-size: 8px;

//           letter-spacing: 0.6px;

//           text-transform: uppercase;
//         }

//         /* =====================================================
//            DELIVERABLES
//         ===================================================== */

//         .sg-deliverables {
//           margin-top: 105px;
//         }

//         .sg-deliverables-header {
//           text-align: center;

//           max-width: 720px;

//           margin: 0 auto 45px;
//         }

//         .sg-deliverables-label {
//           color: #f39818;

//           font-size: 10px;

//           font-weight: 800;

//           letter-spacing: 1.4px;

//           text-transform: uppercase;
//         }

//         .sg-deliverables-title {
//           margin: 10px 0 13px;

//           color: #10213f;

//           font-size: clamp(30px, 3vw, 43px);

//           line-height: 1.1;

//           letter-spacing: -1.4px;

//           font-weight: 800;
//         }

//         .sg-deliverables-text {
//           margin: 0;

//           color: #7a8799;

//           font-size: 13px;

//           line-height: 1.7;
//         }

//         .sg-deliverables-grid {
//           display: grid;

//           grid-template-columns:
//             repeat(4, 1fr);

//           gap: 15px;
//         }

//         .sg-deliverable-card {
//           padding: 28px 23px;

//           text-align: center;

//           border: 1px solid #e0e8f2;

//           border-radius: 15px;

//           background: #ffffff;

//           transition:
//             transform 0.25s ease,
//             box-shadow 0.25s ease,
//             border-color 0.25s ease;
//         }

//         .sg-deliverable-card:hover {
//           transform: translateY(-6px);

//           border-color: #cbdcf0;

//           box-shadow:
//             0 18px 40px rgba(25, 61, 103, 0.09);
//         }

//         .sg-deliverable-icon {
//           width: 51px;
//           height: 51px;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           margin: auto;

//           border-radius: 13px;

//           color: #1558c0;

//           background: #edf4ff;

//           font-size: 20px;

//           font-weight: 700;
//         }

//         .sg-service-icon svg {
//           width: 17px;
//           height: 17px;
//           stroke-width: 2.2;
//         }

//         .sg-deliverable-card h4 {
//           margin: 16px 0 7px;

//           color: #172945;

//           font-size: 14px;

//           font-weight: 800;
//         }

//         .sg-deliverable-card p {
//           margin: 0;

//           color: #8490a0;

//           font-size: 10px;

//           line-height: 1.6;
//         }

//         /* =====================================================
//            CTA
//         ===================================================== */

//         .sg-services-cta {
//           position: relative;

//           display: flex;

//           align-items: center;
//           justify-content: space-between;

//           gap: 30px;

//           margin-top: 80px;

//           padding: 36px 40px;

//           overflow: hidden;

//           border-radius: 18px;

//           background:
//             linear-gradient(
//               110deg,
//               #edf5ff,
//               #f8fbff
//             );

//           border: 1px solid #dbe6f2;
//         }

//         .sg-services-cta::after {
//           content: "";

//           position: absolute;

//           width: 180px;
//           height: 180px;

//           right: -50px;
//           top: -90px;

//           border: 1px solid rgba(21,88,192,0.10);

//           border-radius: 50%;
//         }

//         .sg-services-cta h3 {
//           position: relative;

//           z-index: 2;

//           margin: 0;

//           color: #10213f;

//           font-size: 22px;

//           font-weight: 800;
//         }

//         .sg-services-cta p {
//           position: relative;

//           z-index: 2;

//           margin: 7px 0 0;

//           color: #788598;

//           font-size: 11px;
//         }

//         .sg-services-cta-button {
//           position: relative;

//           z-index: 2;

//           display: inline-flex;

//           align-items: center;
//           justify-content: center;

//           gap: 9px;

//           min-height: 50px;

//           padding: 0 23px;

//           flex-shrink: 0;

//           border-radius: 8px;

//           color: #ffffff;

//           background:
//             linear-gradient(
//               135deg,
//               #1558c0,
//               #2874dd
//             );

//           box-shadow:
//             0 12px 25px rgba(21,88,192,0.20);

//           text-decoration: none;

//           font-size: 11px;

//           font-weight: 800;

//           transition:
//             transform 0.25s ease,
//             box-shadow 0.25s ease;
//         }

//         .sg-services-cta-button:hover {
//           transform: translateY(-3px);

//           box-shadow:
//             0 16px 32px rgba(21,88,192,0.28);
//         }

//         /* =====================================================
//            TABLET
//         ===================================================== */

//         @media (max-width: 1050px) {

//           .sg-services {
//             padding: 95px 0;
//           }

//           .sg-services-heading {
//             gap: 40px;
//           }

//           .sg-service-grid {
//             grid-template-columns:
//               repeat(2, 1fr);
//           }

//           .sg-csi {
//             padding: 40px 30px;
//           }

//           .sg-csi-heading {
//             gap: 40px;
//           }

//           .sg-deliverables-grid {
//             grid-template-columns:
//               repeat(2, 1fr);
//           }
//         }

//         /* =====================================================
//            MOBILE
//         ===================================================== */

//         @media (max-width: 760px) {

//           .sg-services {
//             padding: 80px 0;
//           }

//           .sg-services-heading {
//             grid-template-columns: 1fr;

//             gap: 18px;

//             text-align: center;

//             margin-bottom: 45px;
//           }

//           .sg-services-label {
//             justify-content: center;
//           }

//           .sg-services-title {
//             font-size: 39px;

//             letter-spacing: -1.7px;
//           }

//           .sg-services-intro {
//             margin: auto;

//             font-size: 15px;
//           }

//           .sg-service-grid {
//             grid-template-columns: 1fr;

//             max-width: 550px;

//             margin: auto;
//           }

//           .sg-service-card {
//             min-height: auto;
//           }

//           .sg-service-image {
//             height: 215px;
//           }

//           .sg-csi {
//             margin-top: 75px;

//             padding: 35px 20px;
//           }

//           .sg-csi-heading {
//             grid-template-columns: 1fr;

//             gap: 15px;

//             text-align: center;
//           }

//           .sg-csi-text {
//             max-width: 500px;

//             margin: auto;
//           }

//           .sg-csi-grid {
//             grid-template-columns: 1fr;
//           }

//           .sg-deliverables {
//             margin-top: 75px;
//           }

//           .sg-deliverables-title {
//             font-size: 31px;
//           }

//           .sg-deliverables-grid {
//             grid-template-columns: 1fr 1fr;
//           }

//           .sg-services-cta {
//             display: block;

//             text-align: center;

//             padding: 30px 20px;
//           }

//           .sg-services-cta-button {
//             width: 100%;

//             margin-top: 22px;
//           }
//         }

//         /* =====================================================
//            SMALL MOBILE
//         ===================================================== */

//         @media (max-width: 480px) {

//           .sg-services {
//             padding: 65px 0;
//           }

//           .sg-services-title {
//             font-size: 35px;
//           }

//           .sg-service-image {
//             height: 195px;
//           }

//           .sg-service-content {
//             padding: 20px;
//           }

//           .sg-csi-title {
//             font-size: 28px;
//           }

//           .sg-deliverables-grid {
//             grid-template-columns: 1fr;
//           }

//           .sg-services-cta h3 {
//             font-size: 20px;
//           }
//         }

//         .sg-deliverable-icon svg {
//           width: 22px;
//           height: 22px;
//           stroke-width: 2;
//         }

//         .sg-cta-icon {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .sg-cta-icon svg {
//           width: 16px;
//           height: 16px;
//           stroke-width: 2.5;
//         }

//       `}</style>

//       <section
//         className="sg-services"
//         id="services"
//         ref={sectionRef}
//       >
//         <div className="sg-services-blueprint"></div>

//         <div className="sg-services-container">

//           {/* =================================================
//               HEADER
//           ================================================= */}

//           <div
//             className={`sg-services-heading ${
//               visible ? "visible" : ""
//             }`}
//           >
//             <div>
//               <div className="sg-services-label">
//                 <span className="sg-services-label-line"></span>
//                 Our Services
//               </div>

//               <h2 className="sg-services-title">
//                 Estimating Built
//                 <br />
//                 Around <span>Your Bid.</span>
//               </h2>
//             </div>

//             <p className="sg-services-intro">
//               From detailed quantity takeoffs to complete
//               construction cost estimates, StructGuard provides
//               the estimating support contractors need to
//               understand project scope, evaluate costs, and
//               prepare competitive bids.
//             </p>
//           </div>

//           {/* =================================================
//               SERVICES GRID
//           ================================================= */}

//           <div className="sg-service-grid">
//             {services.map((service) => (
//               <article
//                 className={`sg-service-card ${
//                   visible ? "visible" : ""
//                 }`}
//                 key={service.id}
//                 onMouseEnter={() =>
//                   setActiveService(service.id)
//                 }
//                 onMouseLeave={() =>
//                   setActiveService(null)
//                 }
//               >
//                 {/* IMAGE */}
//                 <div className="sg-service-image">
//                   <img
//                     src={service.image}
//                     alt={service.title}
//                   />

//                   <div className="sg-service-number">
//                     {service.id}
//                   </div>

//                   <div className="sg-service-icon">
//                     <service.icon />
//                   </div>
//                 </div>

//                 {/* CONTENT */}
//                 <div className="sg-service-content">
//                   <h3 className="sg-service-title">
//                     {service.title}
//                   </h3>

//                   <div className="sg-service-short">
//                     {service.short}
//                   </div>

//                   <p className="sg-service-description">
//                     {service.description}
//                   </p>

//                   <div className="sg-service-deliverables">
//                     {service.deliverables.map((item) => (
//                       <div
//                         className="sg-service-deliverable"
//                         key={item}
//                       >
//                         <FiCheckCircle />
//                         {item}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </article>
//             ))}
//           </div>

//           {/* =================================================
//               CSI DIVISIONS (ACTIVATED)
//           ================================================= */}

//           <div className="sg-csi">
//             <div className="sg-csi-heading">
//               <div>
//                 <div className="sg-csi-label">
//                   CSI DIVISION COVERAGE
//                 </div>

//                 <h3 className="sg-csi-title">
//                   One estimating partner.
//                   <br />
//                   Multiple construction trades.
//                 </h3>
//               </div>

//               <p className="sg-csi-text">
//                 Our estimating capabilities span multiple
//                 construction divisions, giving contractors
//                 access to organized cost information across
//                 diverse project scopes.
//               </p>
//             </div>

//             <div className="sg-csi-grid">
//               {divisions.map((division) => (
//                 <div
//                   className="sg-csi-card"
//                   key={division.number}
//                 >
//                   <div className="sg-csi-number">
//                     {division.number}
//                   </div>

//                   <div>
//                     <strong>{division.title}</strong>
//                     <span>CSI Division</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* =================================================
//               DELIVERABLES
//           ================================================= */}

//           <div className="sg-deliverables">
//             <div className="sg-deliverables-header">
//               <div className="sg-deliverables-label">
//                 WHAT YOU RECEIVE
//               </div>

//               <h3 className="sg-deliverables-title">
//                 Clear. Organized. Ready to Use.
//               </h3>

//               <p className="sg-deliverables-text">
//                 Every project is structured around delivering
//                 practical estimating information your team can
//                 review and use for bidding and project planning.
//               </p>
//             </div>

//             <div className="sg-deliverables-grid">
//               {deliverables.map((item) => (
//                 <div
//                   className="sg-deliverable-card"
//                   key={item.title}
//                 >
//                   <div className="sg-deliverable-icon">
//                     <item.icon />
//                   </div>

//                   <h4>{item.title}</h4>

//                   <p>{item.text}</p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* =================================================
//               CTA
//           ================================================= */}

//           <div className="sg-services-cta">
//             <div>
//               <h3>
//                 Have a project ready for estimating?
//               </h3>

//               <p>
//                 Share your drawings and project details with
//                 StructGuard and let us prepare the numbers.
//               </p>
//             </div>

//             <a
//               href="#contact"
//               className="sg-services-cta-button"
//             >
//               REQUEST AN ESTIMATE

//               <span>
//                 <FiArrowUpRight />
//               </span>
//             </a>
//           </div>

//         </div>
//       </section>
//     </>
//   );
// };

// export default Services;

import React, { useEffect, useRef, useState } from "react";
import {
  FiLayers,
  FiDollarSign,
  FiArrowUpRight,
  FiBox,
  FiPieChart,
  FiHome,
  FiCheckCircle,
  FiFileText,
  FiSearch,
  FiClipboard,
  FiTool,
  FiCpu,
  FiSettings,
} from "react-icons/fi";

const Services = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [activeService, setActiveService] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      id: "01",
      title: "Quantity Takeoffs",
      short: "Precise quantities from your drawings.",
      description:
        "We extract, measure, organize, and quantify construction materials and components from architectural, structural, civil, and project drawings.",
      image:
        "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=90",
      icon: FiLayers,
      deliverables: [
        "Material quantities",
        "Trade-specific takeoffs",
        "Drawing-based measurements",
        "Quantity breakdowns",
      ],
    },

    {
      id: "02",
      title: "Construction Estimating",
      short: "Detailed project cost development.",
      description:
        "We develop structured estimates covering material, labor, equipment, subcontractor scope, and other applicable project costs.",
      image:
        "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=90",
      icon: FiDollarSign,
      deliverables: [
        "Material costs",
        "Labor costs",
        "Equipment costs",
        "Trade-level pricing",
      ],
    },

    {
      id: "03",
      title: "Pre-Construction Services",
      short: "Strategic planning before ground breaks.",
      description:
        "Comprehensive pre-construction planning, feasibility assessments, value engineering, and budgeting to align project scope with financial goals.",
      image:
        "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=90",
      icon: FiHome,
      deliverables: [
        "Feasibility studies",
        "Value engineering",
        "Budget planning",
        "Scheduling support",
      ],
    },

    {
      id: "04",
      title: "BIM Services",
      short: "Intelligent 3D modeling and coordination.",
      description:
        "Advanced Building Information Modeling (BIM) for clash detection, 3D visualization, spatial coordination, and precise digital construction documentation.",
      image:
        "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=1200&q=90",
      icon: FiCpu,
      deliverables: [
        "3D coordination models",
        "Clash detection reports",
        "Revit family creation",
        "Digital fabrication support",
      ],
    },

    {
      id: "05",
      title: "Project Engineering",
      short: "Technical oversight and engineering solutions.",
      description:
        "Rigorous technical coordination, constructibility reviews, submittal reviews, and field engineering support to maintain structural integrity and compliance.",
      image:
        "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=90",
      icon: FiSettings,
      deliverables: [
        "Constructibility analysis",
        "Technical submittals",
        "Engineering reviews",
        "Site support documentation",
      ],
    },

    {
      id: "06",
      title: "Bid Preparation",
      short: "Better numbers for competitive bids.",
      description:
        "We organize project scope and cost information to support contractors during bid preparation, review, and submission.",
      image:
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=90",
      icon: FiArrowUpRight,
      deliverables: [
        "Bid-ready estimates",
        "Scope breakdowns",
        "Cost summaries",
        "Bid review support",
      ],
    },
  ];

  const divisions = [
    {
      number: "01",
      title: "General Requirements / GC",
      text: "Project administration, temporary facilities, general conditions, and related requirements.",
    },
    {
      number: "02",
      title: "Existing Conditions",
      text: "Existing construction, demolition, removals, and site condition scope.",
    },
    {
      number: "03",
      title: "Concrete",
      text: "Foundations, slabs, structural concrete, reinforcing, formwork, and related work.",
    },
    {
      number: "04",
      title: "Masonry",
      text: "Concrete masonry units, brick, stone, mortar, reinforcing, and masonry accessories.",
    },
    {
      number: "05",
      title: "Metals",
      text: "Structural steel, miscellaneous metals, metal fabrications, and related components.",
    },
    {
      number: "07",
      title: "Thermal & Moisture Protection",
      text: "Roofing, waterproofing, insulation, sealants, flashing, and moisture protection.",
    },
    {
      number: "08",
      title: "Openings",
      text: "Doors, frames, hardware, windows, glazing, and related opening systems.",
    },
    {
      number: "09",
      title: "Finishes",
      text: "Drywall, ceilings, flooring, painting, coatings, and interior finish systems.",
    },
    {
      number: "32",
      title: "Exterior Improvements",
      text: "Paving, landscaping, site furnishings, curbs, exterior structures, and improvements.",
    },
  ];

  const deliverables = [
    {
      icon: FiLayers,
      title: "Detailed Takeoff",
      text: "Organized quantities by trade and scope.",
    },
    {
      icon: FiDollarSign,
      title: "Cost Estimate",
      text: "Material and labor cost information.",
    },
    {
      icon: FiCpu,
      title: "BIM Models",
      text: "Accurate coordination and clash-free models.",
    },
    {
      icon: FiCheckCircle,
      title: "Quality Review",
      text: "Structured review before final delivery.",
    },
  ];

  return (
    <>
      <style>{`

        /* =====================================================
           SERVICES SECTION
        ===================================================== */

        .sg-services {
          position: relative;
          overflow: hidden;

          padding: 125px 0;

          background: #f7faff;
        }

        .sg-services-container {
          position: relative;
          z-index: 2;

          width: min(1380px, 92%);
          margin: auto;
        }

        /* =====================================================
           BLUEPRINT BACKGROUND
        ===================================================== */

        .sg-services-blueprint {
          position: absolute;

          top: 0;
          left: -180px;

          width: 650px;
          height: 650px;

          opacity: 0.42;

          background-image:
            linear-gradient(
              rgba(24, 87, 173, 0.055) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(24, 87, 173, 0.055) 1px,
              transparent 1px
            );

          background-size: 35px 35px;

          transform: rotate(-5deg);

          pointer-events: none;
        }

        .sg-services-blueprint::after {
          content: "";

          position: absolute;

          width: 350px;
          height: 350px;

          left: 170px;
          top: 130px;

          border: 1px solid rgba(23, 88, 180, 0.08);

          transform: rotate(25deg);
        }

        /* =====================================================
           HEADER
        ===================================================== */

        .sg-services-heading {
          display: grid;

          grid-template-columns: 0.9fr 1.1fr;

          gap: 80px;

          align-items: end;

          margin-bottom: 65px;

          opacity: 0;

          transform: translateY(30px);

          transition:
            opacity 0.7s ease,
            transform 0.7s ease;
        }

        .sg-services-heading.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .sg-services-label {
          display: inline-flex;

          align-items: center;

          gap: 9px;

          color: #175bc3;

          font-size: 12px;

          font-weight: 800;

          letter-spacing: 1.5px;

          text-transform: uppercase;
        }

        .sg-services-label-line {
          width: 30px;
          height: 2px;

          border-radius: 10px;

          background: #f39818;
        }

        .sg-services-title {
          margin: 16px 0 0;

          color: #10213f;

          font-size: clamp(40px, 4.2vw, 62px);

          line-height: 1.04;

          letter-spacing: -2.5px;

          font-weight: 800;
        }

        .sg-services-title span {
          color: #1b60c8;
        }

        .sg-services-intro {
          max-width: 650px;

          margin: 0;

          color: #68768a;

          font-size: 16px;

          line-height: 1.8;
        }

        /* =====================================================
           SERVICE CARDS
        ===================================================== */

        .sg-service-grid {
          display: grid;

          grid-template-columns:
            repeat(3, minmax(0, 1fr));

          gap: 20px;
        }

        .sg-service-card {
          position: relative;

          overflow: hidden;

          min-height: 440px;

          border: 1px solid #dfe8f2;

          border-radius: 18px;

          background: #ffffff;

          box-shadow:
            0 12px 35px rgba(25, 61, 103, 0.055);

          opacity: 0;

          transform: translateY(35px);

          transition:
            opacity 0.7s ease,
            transform 0.7s ease,
            box-shadow 0.3s ease,
            border-color 0.3s ease;
        }

        .sg-service-card.visible {
          opacity: 1;

          transform: translateY(0);
        }

        .sg-service-card:nth-child(2) {
          transition-delay: 0.08s;
        }

        .sg-service-card:nth-child(3) {
          transition-delay: 0.16s;
        }

        .sg-service-card:nth-child(4) {
          transition-delay: 0.24s;
        }

        .sg-service-card:nth-child(5) {
          transition-delay: 0.32s;
        }

        .sg-service-card:nth-child(6) {
          transition-delay: 0.40s;
        }

        .sg-service-card:hover {
          transform: translateY(-8px);

          border-color: #cadcf1;

          box-shadow:
            0 25px 60px rgba(25, 61, 103, 0.13);
        }

        /* =====================================================
           SERVICE IMAGE
        ===================================================== */

        .sg-service-image {
          position: relative;

          height: 190px;

          overflow: hidden;
        }

        .sg-service-image img {
          width: 100%;
          height: 100%;

          display: block;

          object-fit: cover;

          transition:
            transform 0.55s ease,
            filter 0.55s ease;
        }

        .sg-service-card:hover
        .sg-service-image img {
          transform: scale(1.07);

          filter: saturate(1.05);
        }

        .sg-service-image::after {
          content: "";

          position: absolute;

          inset: 0;

          background:
            linear-gradient(
              180deg,
              rgba(10, 39, 73, 0.03),
              rgba(10, 39, 73, 0.43)
            );
        }

        /* =====================================================
           NUMBER
        ===================================================== */

        .sg-service-number {
          position: absolute;

          z-index: 3;

          top: 14px;
          left: 14px;

          width: 40px;
          height: 40px;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 9px;

          color: #1558c0;

          background: rgba(255,255,255,0.94);

          font-size: 11px;

          font-weight: 900;

          box-shadow:
            0 8px 20px rgba(15, 45, 80, 0.12);
        }

        /* =====================================================
           ICON
        ===================================================== */

        .sg-service-icon {
          position: absolute;

          z-index: 3;

          right: 15px;
          top: 15px;

          width: 38px;
          height: 38px;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 50%;

          color: white;

          background: #1558c0;

          border: 3px solid rgba(255,255,255,0.8);

          font-size: 13px;
        }

        /* =====================================================
           CARD CONTENT
        ===================================================== */

        .sg-service-content {
          padding: 22px 22px 20px;
        }

        .sg-service-title {
          margin: 0;

          color: #132641;

          font-size: 19px;

          line-height: 1.2;

          font-weight: 800;
        }

        .sg-service-short {
          margin: 7px 0 0;

          color: #1558c0;

          font-size: 10px;

          font-weight: 800;

          letter-spacing: 0.2px;
        }

        .sg-service-description {
          margin: 13px 0 0;

          color: #798598;

          font-size: 11px;

          line-height: 1.7;
        }

        /* =====================================================
           DELIVERABLES
        ===================================================== */

        .sg-service-deliverables {
          display: grid;

          grid-template-columns: 1fr 1fr;

          gap: 7px;

          margin-top: 17px;

          padding-top: 15px;

          border-top: 1px solid #edf1f5;
        }

        .sg-service-deliverable {
          display: flex;

          align-items: center;

          gap: 6px;

          color: #617086;

          font-size: 9px;

          font-weight: 600;
        }

        .sg-service-deliverable svg {
          width: 14px;
          height: 14px;
          flex-shrink: 0;
          color: #168258;
          stroke-width: 2.2;
        }

        /* =====================================================
           CSI DIVISIONS
        ===================================================== */

        .sg-csi {
          margin-top: 105px;

          padding: 55px;

          border-radius: 24px;

          background:
            linear-gradient(
              135deg,
              #102b4d 0%,
              #174f8d 100%
            );

          box-shadow:
            0 25px 65px rgba(17, 51, 88, 0.18);

          position: relative;

          overflow: hidden;
        }

        .sg-csi::before {
          content: "";

          position: absolute;

          width: 480px;
          height: 480px;

          right: -200px;
          top: -250px;

          border: 1px solid rgba(255,255,255,0.09);

          border-radius: 50%;
        }

        .sg-csi::after {
          content: "";

          position: absolute;

          width: 300px;
          height: 300px;

          right: -110px;
          top: -160px;

          border: 1px dashed rgba(255,255,255,0.08);

          border-radius: 50%;
        }

        .sg-csi-heading {
          position: relative;

          z-index: 2;

          display: grid;

          grid-template-columns: 1fr 0.7fr;

          gap: 70px;

          align-items: end;

          margin-bottom: 38px;
        }

        .sg-csi-label {
          color: #f7a62c;

          font-size: 10px;

          font-weight: 800;

          letter-spacing: 1.5px;

          text-transform: uppercase;
        }

        .sg-csi-title {
          margin: 10px 0 0;

          color: white;

          font-size: clamp(30px, 3.1vw, 44px);

          line-height: 1.1;

          letter-spacing: -1.4px;

          font-weight: 800;
        }

        .sg-csi-text {
          margin: 0;

          color: rgba(255,255,255,0.65);

          font-size: 12px;

          line-height: 1.75;
        }

        .sg-csi-grid {
          position: relative;

          z-index: 2;

          display: grid;

          grid-template-columns:
            repeat(3, 1fr);

          gap: 10px;
        }

        .sg-csi-card {
          display: flex;

          align-items: center;

          gap: 13px;

          min-height: 72px;

          padding: 11px 14px;

          border: 1px solid rgba(255,255,255,0.10);

          border-radius: 11px;

          background: rgba(255,255,255,0.065);

          transition:
            background 0.25s ease,
            transform 0.25s ease,
            border-color 0.25s ease;
        }

        .sg-csi-card:hover {
          transform: translateY(-3px);

          background: rgba(255,255,255,0.12);

          border-color: rgba(255,255,255,0.20);
        }

        .sg-csi-number {
          width: 40px;
          height: 40px;

          flex-shrink: 0;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 8px;

          color: #16529d;

          background: #ffffff;

          font-size: 11px;

          font-weight: 900;
        }

        .sg-csi-card strong {
          display: block;

          color: white;

          font-size: 11px;

          line-height: 1.35;
        }

        .sg-csi-card span {
          display: block;

          margin-top: 3px;

          color: rgba(255,255,255,0.43);

          font-size: 8px;

          letter-spacing: 0.6px;

          text-transform: uppercase;
        }

        /* =====================================================
           DELIVERABLES
        ===================================================== */

        .sg-deliverables {
          margin-top: 105px;
        }

        .sg-deliverables-header {
          text-align: center;

          max-width: 720px;

          margin: 0 auto 45px;
        }

        .sg-deliverables-label {
          color: #f39818;

          font-size: 10px;

          font-weight: 800;

          letter-spacing: 1.4px;

          text-transform: uppercase;
        }

        .sg-deliverables-title {
          margin: 10px 0 13px;

          color: #10213f;

          font-size: clamp(30px, 3vw, 43px);

          line-height: 1.1;

          letter-spacing: -1.4px;

          font-weight: 800;
        }

        .sg-deliverables-text {
          margin: 0;

          color: #7a8799;

          font-size: 13px;

          line-height: 1.7;
        }

        .sg-deliverables-grid {
          display: grid;

          grid-template-columns:
            repeat(4, 1fr);

          gap: 15px;
        }

        .sg-deliverable-card {
          padding: 28px 23px;

          text-align: center;

          border: 1px solid #e0e8f2;

          border-radius: 15px;

          background: #ffffff;

          transition:
            transform 0.25s ease,
            box-shadow 0.25s ease,
            border-color 0.25s ease;
        }

        .sg-deliverable-card:hover {
          transform: translateY(-6px);

          border-color: #cbdcf0;

          box-shadow:
            0 18px 40px rgba(25, 61, 103, 0.09);
        }

        .sg-deliverable-icon {
          width: 51px;
          height: 51px;

          display: flex;

          align-items: center;
          justify-content: center;

          margin: auto;

          border-radius: 13px;

          color: #1558c0;

          background: #edf4ff;

          font-size: 20px;

          font-weight: 700;
        }

        .sg-service-icon svg {
          width: 17px;
          height: 17px;
          stroke-width: 2.2;
        }

        .sg-deliverable-card h4 {
          margin: 16px 0 7px;

          color: #172945;

          font-size: 14px;

          font-weight: 800;
        }

        .sg-deliverable-card p {
          margin: 0;

          color: #8490a0;

          font-size: 10px;

          line-height: 1.6;
        }

        /* =====================================================
           CTA
        ===================================================== */

        .sg-services-cta {
          position: relative;

          display: flex;

          align-items: center;
          justify-content: space-between;

          gap: 30px;

          margin-top: 80px;

          padding: 36px 40px;

          overflow: hidden;

          border-radius: 18px;

          background:
            linear-gradient(
              110deg,
              #edf5ff,
              #f8fbff
            );

          border: 1px solid #dbe6f2;
        }

        .sg-services-cta::after {
          content: "";

          position: absolute;

          width: 180px;
          height: 180px;

          right: -50px;
          top: -90px;

          border: 1px solid rgba(21,88,192,0.10);

          border-radius: 50%;
        }

        .sg-services-cta h3 {
          position: relative;

          z-index: 2;

          margin: 0;

          color: #10213f;

          font-size: 22px;

          font-weight: 800;
        }

        .sg-services-cta p {
          position: relative;

          z-index: 2;

          margin: 7px 0 0;

          color: #788598;

          font-size: 11px;
        }

        .sg-services-cta-button {
          position: relative;

          z-index: 2;

          display: inline-flex;

          align-items: center;
          justify-content: center;

          gap: 9px;

          min-height: 50px;

          padding: 0 23px;

          flex-shrink: 0;

          border-radius: 8px;

          color: #ffffff;

          background:
            linear-gradient(
              135deg,
              #1558c0,
              #2874dd
            );

          box-shadow:
            0 12px 25px rgba(21,88,192,0.20);

          text-decoration: none;

          font-size: 11px;

          font-weight: 800;

          transition:
            transform 0.25s ease,
            box-shadow 0.25s ease;
        }

        .sg-services-cta-button:hover {
          transform: translateY(-3px);

          box-shadow:
            0 16px 32px rgba(21,88,192,0.28);
        }

        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 1050px) {

          .sg-services {
            padding: 95px 0;
          }

          .sg-services-heading {
            gap: 40px;
          }

          .sg-service-grid {
            grid-template-columns:
              repeat(2, 1fr);
          }

          .sg-csi {
            padding: 40px 30px;
          }

          .sg-csi-heading {
            gap: 40px;
          }

          .sg-deliverables-grid {
            grid-template-columns:
              repeat(2, 1fr);
          }
        }

        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 760px) {

          .sg-services {
            padding: 80px 0;
          }

          .sg-services-heading {
            grid-template-columns: 1fr;

            gap: 18px;

            text-align: center;

            margin-bottom: 45px;
          }

          .sg-services-label {
            justify-content: center;
          }

          .sg-services-title {
            font-size: 39px;

            letter-spacing: -1.7px;
          }

          .sg-services-intro {
            margin: auto;

            font-size: 15px;
          }

          .sg-service-grid {
            grid-template-columns: 1fr;

            max-width: 550px;

            margin: auto;
          }

          .sg-service-card {
            min-height: auto;
          }

          .sg-service-image {
            height: 215px;
          }

          .sg-csi {
            margin-top: 75px;

            padding: 35px 20px;
          }

          .sg-csi-heading {
            grid-template-columns: 1fr;

            gap: 15px;

            text-align: center;
          }

          .sg-csi-text {
            max-width: 500px;

            margin: auto;
          }

          .sg-csi-grid {
            grid-template-columns: 1fr;
          }

          .sg-deliverables {
            margin-top: 75px;
          }

          .sg-deliverables-title {
            font-size: 31px;
          }

          .sg-deliverables-grid {
            grid-template-columns: 1fr 1fr;
          }

          .sg-services-cta {
            display: block;

            text-align: center;

            padding: 30px 20px;
          }

          .sg-services-cta-button {
            width: 100%;

            margin-top: 22px;
          }
        }

        /* =====================================================
           SMALL MOBILE
        ===================================================== */

        @media (max-width: 480px) {

          .sg-services {
            padding: 65px 0;
          }

          .sg-services-title {
            font-size: 35px;
          }

          .sg-service-image {
            height: 195px;
          }

          .sg-service-content {
            padding: 20px;
          }

          .sg-csi-title {
            font-size: 28px;
          }

          .sg-deliverables-grid {
            grid-template-columns: 1fr;
          }

          .sg-services-cta h3 {
            font-size: 20px;
          }
        }

        .sg-deliverable-icon svg {
          width: 22px;
          height: 22px;
          stroke-width: 2;
        }

        .sg-cta-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .sg-cta-icon svg {
          width: 16px;
          height: 16px;
          stroke-width: 2.5;
        }

      `}</style>

      <section
        className="sg-services"
        id="services"
        ref={sectionRef}
      >
        <div className="sg-services-blueprint"></div>

        <div className="sg-services-container">

          {/* =================================================
              HEADER
          ================================================= */}

          <div
            className={`sg-services-heading ${
              visible ? "visible" : ""
            }`}
          >
            <div>
              <div className="sg-services-label">
                <span className="sg-services-label-line"></span>
                Our Services
              </div>

              <h2 className="sg-services-title">
                Estimating Built
                <br />
                Around <span>Your Bid.</span>
              </h2>
            </div>

            <p className="sg-services-intro">
              From detailed quantity takeoffs and BIM coordination to complete
              construction cost estimates, StructGuard provides
              the engineering and estimating support contractors need to
              succeed on every project.
            </p>
          </div>

          {/* =================================================
              SERVICES GRID
          ================================================= */}

          <div className="sg-service-grid">
            {services.map((service) => (
              <article
                className={`sg-service-card ${
                  visible ? "visible" : ""
                }`}
                key={service.id}
                onMouseEnter={() =>
                  setActiveService(service.id)
                }
                onMouseLeave={() =>
                  setActiveService(null)
                }
              >
                {/* IMAGE */}
                <div className="sg-service-image">
                  <img
                    src={service.image}
                    alt={service.title}
                  />

                  <div className="sg-service-number">
                    {service.id}
                  </div>

                  <div className="sg-service-icon">
                    <service.icon />
                  </div>
                </div>

                {/* CONTENT */}
                <div className="sg-service-content">
                  <h3 className="sg-service-title">
                    {service.title}
                  </h3>

                  <div className="sg-service-short">
                    {service.short}
                  </div>

                  <p className="sg-service-description">
                    {service.description}
                  </p>

                  <div className="sg-service-deliverables">
                    {service.deliverables.map((item) => (
                      <div
                        className="sg-service-deliverable"
                        key={item}
                      >
                        <FiCheckCircle />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* =================================================
              DELIVERABLES
          ================================================= */}

          <div className="sg-deliverables">
            <div className="sg-deliverables-header">
              <div className="sg-deliverables-label">
                WHAT YOU RECEIVE
              </div>

              <h3 className="sg-deliverables-title">
                Clear. Organized. Ready to Use.
              </h3>

              <p className="sg-deliverables-text">
                Every project is structured around delivering
                practical estimating and engineering information your team can
                review and use for bidding and project planning.
              </p>
            </div>

            <div className="sg-deliverables-grid">
              {deliverables.map((item) => (
                <div
                  className="sg-deliverable-card"
                  key={item.title}
                >
                  <div className="sg-deliverable-icon">
                    <item.icon />
                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* =================================================
              CTA
          ================================================= */}

          <div className="sg-services-cta">
            <div>
              <h3>
                Have a project ready for estimating or engineering?
              </h3>

              <p>
                Share your drawings and project details with
                StructGuard and let our experts prepare the numbers and models.
              </p>
            </div>

            <a
              href="#contact"
              className="sg-services-cta-button"
            >
              REQUEST AN ESTIMATE

              <span>
                <FiArrowUpRight />
              </span>
            </a>
          </div>

        </div>
      </section>
    </>
  );
};

export default Services;